import Swiper, { A11y } from 'swiper';
import BaseComponent from '../base/baseComponent';
Swiper.use([A11y]);
export default class ImagesModule extends BaseComponent {
    constructor(element) {
        super(element);
        this.initSlider();
    }
    initSlider() {
        const mainSlider = this.$el;
        const loop = mainSlider.classList.contains('slider-wrapper--infinite-slider');
        new Swiper(mainSlider, {
            loop: loop,
            freeMode: true,
            slidesPerView: 'auto',
            spaceBetween: 0,
            a11y: {
                enabled: true,
                firstSlideMessage: this.$options.firstslidemessage,
                lastSlideMessage: this.$options.lastslidemessage,
            },
        });
    }
}
